module.exports = __webpack_public_path__ + "img/south-africa.cc381489.svg";